import { FileIcon } from './FileIcon';

/**
 * author: Google
 * id BFF59001-B52D-47E6-A217-C9095F81C3B8
 * name file
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file.svg
 * tags
 * - Files / Folders 
 */
export const InsertDriveFileIcon = FileIcon;
export default InsertDriveFileIcon